// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Lsak","footer":"Form_footer__30Gjm"};